<i18n>
{
  "ja": {
    "copyrights": "copyright ©️ iwa co, ltd.",
    "description": "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ソフトウェア開発と情報技術の最前線に立つ企業として、日本のインターネットサービス業界に対して革新的なソフトウェアソリューション、先進的製品、および強力なプラットフォームを提供している。",
    "links": "ナビゲーション",
    "contact": {
      "company": "会社名",
      "company_value": "株式会社iWA（iWA Inc.）",
      "post": "代表取締役CEO",
      "post_value": "masahiro mine",
      "address": "所在地",
      "address_value": "東京都品川区小山3丁目14番2-11F"
    }
  },
  "en": {
    "copyrights": "copyright ©️ iwa co, ltd.",
    "description": "As a company at the forefront of software development and information technology, we provide the Japanese internet service industry with innovative software solutions, advanced products, and powerful platforms.",
    "links": "Navigation:",
    "contact": {
      "company": "Company",
      "company_value": "iWA Corporation",
      "post": "CEO",
      "post_value": "masahiro mine",
      "address": "Address",
      "address_value": "2-11F, 3-14 Koyama, Shinagawa-ku, Tokyo"
    }
  }
}
</i18n>
<template>
  <footer class="e-footer footer-bg strong-text--text" :class="{'phone': phoneOnly}">
    <v-container data-aos="fade-up" data-aos-duration="600" class="row-container text--text py-10">
      <v-row>
        <v-col :cols="pcOnly ? 4 : 12" class="pe-lg-12"
               :class="{'d-flex text-center justify-center align-center flex-column': phoneOnly}">
          <v-container class="d-flex justify-center">
            <logo width="160"/>
          </v-container>
          <div class="footer-content mt-6 mt-lg-10 justify-center" v-html="$t('description')">
          </div>
        </v-col>
        <template v-if="pcOnly">
          <v-col :cols="pcOnly ? 3 : 12" class="px-lg-12 justify-center align-center">
            <v-list color="footer-bg" dark>
              <v-list-item v-for="link in links" :key="link.name" large tile text class="ms-2"
                           @click="navigateToLink(link.ref)">
                <v-list-item-title class="strong-text--text">{{ $t(`links.${link.name}`) }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-col>
        </template>
          <v-col :cols="pcOnly ? 5 : 12" class="ps-lg-12">
            <v-list color="footer-bg" dark class="text--text" two-line>
              <v-list-item v-for="item in contactItems" :key="item.name" :target="item.href ? '_blank' : ''"
                           :href="item.href ? item.href : (item.name === 'email' ? `mailto:${item.value}` : '')">
                <v-list-item-icon>
                  <v-icon :color="item.color">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-2">{{ $t('contact.' + item.name) }}</v-list-item-subtitle>
                  <v-list-item-title>{{ $t('contact.' + item.value) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
      </v-row>
    </v-container>
    <v-spacer/>
    <div class="footer-watermark flex-column">
      <v-container class="text-center py-0">
        <div>© 2023 {{ $t('copyrights') }}</div>
      </v-container>
    </div>
  </footer>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import Logo from './logo'
import links from '@/helpers/links'

export default {
  name: 'e-footer',
  props: {
    light: {
      type: Boolean,
      default: false,
    }
  },
  components: {Logo},

  data() {
    return {
      links,
      contactItems: [
        {
            name: 'company',
            value: 'company_value',
            color: 'white'
        },
        {
            name: 'post',
            value: 'post_value',
            color: 'white'
        },
        {
            name: 'address',
            value: 'address_value',
            color: 'white'
        },
      ],
    }
  },
  computed: {
    ...GlobalComputed,
  },
  methods: {

    ...GlobalMethods,
  },
}
</script>
<style lang="scss" scoped>
.e-footer {
  min-height: 500px;
  display: flex;
  justify-content: center;
  align-content: stretch;
  flex-direction: column;

  &.phone {
    min-height: 400px;
  }

  .footer-watermark {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, .3);
    line-height: 1.6rem;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 2rem 0;
  }

  .row-container {
    line-height: 1.9rem;
  }
}
</style>
